export const theme = {
  fontSizes: {
    s: "14px",
    m: "18px",
    l: "20px",
    xl: "24px",
    xsl: "28px",
    xxl: "32px",
  },

  fontWeight: {
    normal: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
  },

  fontStyle: {
    normal: "normal",
  },

  fontFamily: {},

  lineHeight: {
    normal: 1.5,
  },

  colors: {
    accent: {
      green: "#d4fe75",
      light_green: "#f2ffd7",
      red: "#d80027",
      pink: "#f8465e",
      yellow: "#ffc107",
    },

    secondary: {
      title: "#2f2f37",
      main: "#54535d",
      popular_queries: "#82818e",
      minor: "#A9A9A9",
      lines: "#c5c5c5",
      scroll: "#eaebed",
      stroke: "#edeff2",
      active: "#ececee",
      gray: "#54535D",
    },
    error: {
      main: "#D80027",
      light: "#F8465E",
    },
    hover: {
      background: "#a2e902",
      border: "#c0f052",
    },
    active: {
      background: "#78ac01",
      border: "#a3c751",
    },

    background: "#f7f7f8",
    white: "#ffffff",
    black: "#0c0c0e",
    buttonHover: "#E6E6E6",
    buttonActive: "#CCC",
  },

  linearGradients: {},

  shadows: {},
  //index 0  1  2  3  4   5   6   7   8   9    10
  space: [0, 2, 4, 8, 12, 16, 24, 32, 64, 128, 256],

  radii: {
    small: "6px",
    medium: "12px",
    label: "18px",
    normal: "20px",
    article: "32px",
    big: "35px",
    eBid: "50px",
  },

  screenSizes: {
    mdMin: "600px",
    // mdMax: "900px",
    mdMax: "1000px", // added ru + 20
    tbMax: "1080px",
    lgMin: "1200px",
    lgMax: "",
    xlMin: "",
  },

  transitions: {
    progress: "width 0.5s ease",
  },

  borders: {
    browserInfoTable: "1px solid #edeff2",
    input: "1px solid #edeff2",
  },

  animate: "rotate 1s linear infinite",
};
